import { _ as r } from "../internals/export.js";
import { f as e } from "../internals/freezing.js";
import { f as t } from "../internals/fails.js";
import { i as a } from "../internals/is-object.js";
import { i as n } from "../internals/internal-metadata.js";
var s = n.onFreeze,
  i = Object.freeze;
r({
  target: "Object",
  stat: !0,
  forced: t(function () {
    i(1);
  }),
  sham: !e
}, {
  freeze: function freeze(r) {
    return i && a(r) ? i(s(r)) : r;
  }
});